import dictionary from './questionnaireTranslations.json';

// ---------------------------------------------------------------------------
// Переводы блоков и вопросов анкеты.
//
// Бэкенд отдаёт анкету только на языке по умолчанию: в реестре `GET /languages`
// заведён один английский, а параметр `lang` на `GET /capsule/questionnaire`
// игнорируется. Поэтому до появления переводов на сервере подменяем текст на
// клиенте.
//
// Ключ — идентификатор блока или вопроса, а не английский текст: правка
// формулировки в админке не ломает перевод, а добавленный вопрос просто
// останется на языке сервера.
// ---------------------------------------------------------------------------

const langHandler = (language) => String(language || '').slice(0, 2).toLowerCase();

export const questionnaireBlockTitle = (block, language) => {
    const translated = dictionary?.blocks?.[block?.id]?.[langHandler(language)];
    return translated || block?.title || '';
};

export const questionnaireQuestionText = (question, language) => {
    const translated = dictionary?.questions?.[question?.id]?.[langHandler(language)];
    return translated || question?.text || '';
};
